import { useContext, useEffect, useState } from "react";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { ISimSwap } from "../interface/ISimCharge";
import { getSimSwapChargesRoute } from "@api-routes/eirCustomersFacade";
import { getResponseToState, ISimSwapResponse } from "../mappers/getSimSwapChargesMapper";
import { useFetch } from "@common/hook/useFetch";

export const useGetReplacementCost = () => {
    const { selectedService } = useContext(SelectedServiceContext);
    const [replacementCostDetails, setReplacementCostDetails] = useState<ISimSwap>();

    const [getReplacementCostState, { get }] = useFetch();

    const getReplacementCostDetails = () => {
        if (selectedService) {
            get<ISimSwapResponse>(getSimSwapChargesRoute(selectedService.id)).then((simSwapChargesResponse) => {
                if (simSwapChargesResponse) {
                    const charge = getResponseToState(simSwapChargesResponse)[0];

                    if (charge) {
                        setReplacementCostDetails({
                            name: charge.description,
                            amount: charge.defaultPriceVatIncluded,
                        });
                    }
                }
            });
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getReplacementCostDetails, [selectedService]);

    return { replacementCostDetails, getReplacementCostState, getReplacementCostDetails };
};
